import React from 'react';
import { Switch, Route } from 'react-router';
import AccountBillingEdit from './AccountBillingEdit';

const BillingTab = () => (
  <Switch>
    <Route
      exact
      path={[
        '/dashboard/user/organizations/:id/billing',
        '/dashboard/admin/organizations/:id/billing',
      ]}
    >
      <AccountBillingEdit />
    </Route>
  </Switch>
);
export default BillingTab;
